<template>
    <el-dialog :title="isHistory?'Costco Request Form':'Create Costco Request'"
               :visible.sync="showDialog"
               @close="closeDialog"
               width="60%"
               :close-on-click-modal="false">
        <el-alert :closable="false"
                  v-if="form.isDeleted"
                  type="error">
            <h3 v-if="form.isDeleted">IS DELETED</h3>
        </el-alert>
        <el-alert :closable="false"
                  title="Hardt Tech processing"
                  v-if="isHistory"
                  type="warning">
            Processed by : {{form.processedBy}} <br />
            Processed Date : {{form.processingDate | datetime}}
        </el-alert>

        <el-form :disabled="isSavingInProgress || isHistory"
                 v-loading="loading"
                 ref="form"
                 :model="form"
                 :rules="rules"
                 size="small"
                 label-width="140px"
                 label-position="left">
            <el-form-item label="Ticket #">
                <el-input v-model="form.serviceTicketNumber"
                          disabled
                          type="number"></el-input>
            </el-form-item>
            <el-form-item label="Customer"
                          prop="customerId"
                          class="Customer" :disabled="isHistory">
                <customer-selector :customerName="form.customerName"
                                   v-if="!copyticket"
                                   v-model="form.customerId"
                                   :disabled="!!isHistory"></customer-selector>
            </el-form-item>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="Product"
                                  prop="equipmentId">
                        <equipment-selector v-model="form.equipmentId"
                                            :customerId="form.customerId" @equipmentSelected="equipmentSelected"></equipment-selector>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="Warranty End" style="float:right;">
                        <el-input v-model="equipmentWrtEnd"
                                  disabled
                                  type="text"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="Caller Title"
                          prop="callerTitle"
                          :disabled="isHistory">
                <el-select v-if="!copyticket" v-model="form.callerTitle"
                           class="full-width">
                    <el-option :value="15"
                               label="Food Court Manager"></el-option>
                    <el-option :value="1"
                               label="Deli Manager"></el-option>
                    <el-option :value="14"
                               label="Deli Supervisor"></el-option>
                    <el-option :value="2"
                               label="Meat Manager"></el-option>
                    <el-option :value="3"
                               label="Regional Manager"></el-option>
                    <el-option :value="4"
                               label="Hardt Manager"></el-option>
                    <el-option :value="5"
                               label="Hardt Product Manager"></el-option>
                    <el-option :value="6"
                               label="Warehouse Manager"></el-option>
                    <el-option :value="7"
                               label="Warehouse Manager Assistant"></el-option>
                    <el-option :value="8"
                               label="Operator"></el-option>
                    <el-option :value="9"
                               label="Customer Corporate Request"></el-option>
                    <el-option :value="10"
                               label="Maintenance"></el-option>
                    <el-option :value="11"
                               label="Fresh Manager"></el-option>
                    <el-option :value="12"
                               label="Fresh Manager Assistant"></el-option>
                    <el-option :value="13"
                               label="Other"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Caller Name"
                          prop="requestorName">
                <el-input v-model="form.requestorName"></el-input>
            </el-form-item>
            <el-form-item label="Caller Email"
                          prop="email">
                <el-input v-model="form.email"></el-input>
            </el-form-item>
            <!--<el-form-item label="Caller Phone"
                          prop="mobilePhone">
                <el-input v-model="form.mobilePhone" v-mask="'(###) ###-####'"></el-input>
            </el-form-item>
            <el-form-item label="Second Contact"
                          prop="secondMobilePhone">
                <el-input v-model="form.secondMobilePhone"></el-input>
            </el-form-item>
            -->
            <el-form-item label="Urgency"
                          prop="urgency">
                <el-select v-if="!copyticket" v-model="form.urgency"
                           class="full-width">
                    <el-option :value="1"
                               label="Priority 1 - Down"></el-option>
                    <el-option :value="2"
                               label="Priority 2 - Operational"></el-option>
                    <el-option :value="3"
                               label="Installation"></el-option>
                    <el-option :value="4"
                               label="Post Installation"></el-option>
                    <el-option :value="5"
                               label="Install/Post Install Combo"></el-option>
                    <el-option :value="6"
                               label="Hold"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Status"
                          prop="status">
                <el-select v-model="form.status"
                           class="full-width">
                    <el-option :value="1"
                               label=" "></el-option>
                    <el-option :value="3"
                               label="Flagged"></el-option>
                    <el-option :value="5"
                               label="Escalation"></el-option>
                    <el-option :value="8"
                               label="Standard"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Service Coverage"
                          prop="serviceCoverage">
                <el-select v-if="!copyticket" v-model="form.serviceCoverage"
                           class="full-width">
                    <el-option :value="1"
                               label="Warranty - INVOICE HARDT"></el-option>
                    <el-option :value="2"
                               label="Costco Non-Warranty - INVOICE HARDT"></el-option>
                    <el-option :value="3"
                               label="Costco Preventative Maintenance, Invoice Hardt"></el-option>
                    <el-option :value="4"
                               label="Wal-Mart Non-Warranty - INVOICE HARDT"></el-option>
                    <el-option :value="5"
                               label="Pending Warranty - INVOICE HARDT PENDING DECISION"></el-option>
                    <el-option :value="6"
                               label="Warranty Exception - INVOICE HARDT"></el-option>
                    <el-option :value="7"
                               label="Installation / Post Install"></el-option>
                    <el-option :value="8"
                               label="Non-Warranty / INVOICE Hardt"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Overtime Approved"
                          prop="overtimeApproved">
                <el-select v-model="form.overtimeApproved"
                           class="full-width">
                    <el-option :value="true" label="Yes" />
                    <el-option :value="false" label="No" />

                </el-select>
            </el-form-item>
            <el-form-item label="Communication Requirements"
                          prop="notes">
                <el-input type="textarea"
                          v-model="form.notes"></el-input>
            </el-form-item>
            <el-form-item label="Response time"
                          prop="responseTime">
                <el-select v-model="form.responseTime"
                           class="full-width">
                    <el-option :value="-1"
                               label=" "></el-option>
                    <el-option :value="2"
                               label="2 hrs"></el-option>
                    <el-option :value="4"
                               label="4 hrs"></el-option>
                    <el-option :value="6"
                               label="6 hrs"></el-option>
                </el-select>
            </el-form-item>
            <h4>Symptoms</h4>
            <span style="display:flex; justify-content:space-around;">
                <el-form-item label="Select category" prop="categoryName">
                    <el-select v-model="form.categoryName" class="select" clearable filterable placeholder="Please select category">
                        <el-option v-for="item in form.categories" label="item.category" :value="item.category"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.subCategories && form.subCategories.length >  0 && form.equipmentName && form.equipmentName.includes('I4500')" label="Select subcategory" prop="subCategoryName" style="margin-left:30px;">
                    <el-select v-model="form.subCategoryName" class="select" clearable filterable placeholder="Please select subcategory">
                        <el-option v-for="item in form.subCategories" v-if="form.categoryName" label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </span>
            <el-form-item label="Add symptom">
                <complaint-code-selector :equipmentId="form.equipmentId"
                                         :categoryName="form.categoryName"
                                         :subCategoryName="form.subCategoryName"
                                         @code-selected="appendCode"></complaint-code-selector>
            </el-form-item>
            <el-alert @close="removeCode(complaint.id)"
                      :key="complaint.id"
                      v-for="complaint in form.complaintCodes"
                      :title="complaint.name"
                      type="info"
                      style="margin-bottom: 5px">
            </el-alert>
            <el-form-item label="Previous Calls"
                          v-if="previousTickets.length > 0">
                <el-table :disabled="isSavingInProgress" :data="previousTickets" class="tablewithshading">
                    <el-table-column prop="raisedOn"
                                     label="Date"></el-table-column>
                    <el-table-column prop="id"
                                     label="Ticket #"
                                     width="100"></el-table-column>
                    <el-table-column prop="serialNumber"
                                     label="Serial Number"></el-table-column>
                    <el-table-column prop="note"
                                     label="Description"
                                     min-width="300"></el-table-column>
                    <el-table-column prop="status"
                                     label="Status"
                                     width="100"></el-table-column>
                    <el-table-column label="View"
                                     width="100">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       @click="editTicket(scope.row.id)">
                                <i class="el-icon-view"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: center; margin-top: 10px;">
                    <el-button v-if="!previousTicketsButtonDisabled" style="width: 300px;"
                               @click="getMorePreviousTickets()">
                        Load More
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item label="Ticket Files"
                          prop="attachments">
                <el-upload name="attachments"
                           drag
                           multiple
                           :file-list="form.attachments"
                           :auto-upload="false"
                           :limit="10"
                           action=""
                           :on-change="attachmentChanged"
                           :on-preview="handlePreview">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        Drop file here or
                        <em>click to upload</em>
                    </div>
                </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="danger"
                       v-if="!isHistory"
                       :disabled="isSavingInProgress"
                       @click="deleteServiceRequest">Delete</el-button>
            <el-button type="primary"
                       v-if="!isHistory"
                       :loading="isSavingInProgress && !isCopy"
                       :disabled="isSavingInProgress && isCopy"
                       @click="showEmailDialog">Save</el-button>
            <el-button :disabled="isSavingInProgress"
                       @click="closeDialog">Cancel</el-button>
        </span>
        <el-dialog :visible.sync="showImagePreview"
                   width="60%"
                   append-to-body>
            <img style="width: 100%;"
                 v-bind:src="fileUrlPreview"
                 alt=""
                 v-if="fileExtension!=='pdf'" />
            <embed v-bind:src="fileUrlPreview"
                   style="width: 100%; height: 600px;"
                   type='application/pdf'
                   v-if="fileExtension==='pdf'">
            <el-button @click="showImagePreview = false">Close</el-button>
        </el-dialog>
        <send-email-dialog :visible="showSaveDialog" :loadingChangeEmail="loadingChangeEmail" :formChangeEmail="formChangeEmail" @save="save"></send-email-dialog>
        <el-dialog :visible.sync="showRsMessage"
                   width="30%"
                   append-to-body
                   title="Customer 'RS'">
            <p>
                This is a RS Customer, please apply the appropriate procedures.<br>
                Click 'OK' to proceed or View RS procedures.
            </p>
            <el-button @click="showRsMessage = false">OK</el-button>
            <el-button @click="viewrsprocedures">View RS procedures</el-button>
        </el-dialog>
        <service-ticket-details-dialog :ticketId="ticketToEdit"
                                       :visible="dialogVisible"
                                       @dialogClosed="editFinished"></service-ticket-details-dialog>
    </el-dialog>
</template>

<script>
    import {
        CustomerSelector,
        EquipmentSelector,
        ComplaintCodeSelector,
        CategorySelector
    } from "@/app/shared/components";
    import ServiceTicketDetailsDialog from "../../servicetickets/components/ServiceTicketDetailsDialog";
    import SendEmailDialog from "../../servicetickets/components/SendEmailDialog";
    import api from "../api";
    export default {
        name: "create-service-ticket-from-draft-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            ticketId: {
                type: Number
            },
             isHistory: {
                 type: Boolean,
                 default: false
            }
        },
        components: {
            CustomerSelector,
            EquipmentSelector,
            ComplaintCodeSelector,
            CategorySelector,
            ServiceTicketDetailsDialog,
            SendEmailDialog
        },

        data() {
            this.loading = true

            return {
                id: undefined,
                dialogVisible: false,
                isSavingInProgress: false,
                showRsMessage: false,
                serviceCoverageName: undefined,
                callerTitleValue: undefined,
                urgencyValue: undefined,
                copyticket: false,
                isCopy: false,
                form: {
                    customerName: undefined,
                    customerId: undefined,
                    equipmentId: undefined,
                    categoryName: undefined,
                    equipmentName: undefined,
                    subCategoryName: undefined,
                    callerTitle: undefined,
                    requestorName: "",
                    callerPhoneNumber: "",
                    requestorEmail: "",
                    overtimeApproved: undefined,
                    isConfirmationOnly: false,
                    urgency: undefined,
                    notes: "",
                    status: undefined,
                    serviceCoverage: undefined,
                    complaintCodes: [],
                    attachments: [],
                    categories: [],
                    subCategories: [],
                    responseTime: -1,
                    mobilePhone: undefined,
                    secondMobilePhone: undefined,
                    email: undefined
                },
                rules: {
                    customerId: [
                        {
                            type: "number",
                            required: true,
                            message: "Please select customer",
                            trigger: "change"
                        }
                    ],
                    equipmentId: [
                        {
                            type: "number",
                            required: true,
                            message: "Please select equipment",
                            trigger: "change"
                        }
                    ],
                    callerTitle: [
                        {
                            type: "number",
                            required: true,
                            message: "Please select title",
                            trigger: "change"
                        }
                    ],
                    requestorName: [
                        {
                            required: true,
                            message: "Please enter caller name",
                            trigger: "blur"
                        }
                    ],
                    urgency: [
                        {
                            type: "number",
                            required: true,
                            message: "Please select urgency",
                            trigger: "change"
                        }
                    ],
                    serviceCoverage: [
                        {
                            type: "number",
                            required: true,
                            message: "Please select service coverage",
                            trigger: "change"
                        }
                    ],
                    overtimeApproved: [
                        {
                            required: true,
                            message: "Please select overtime approved",
                            trigger: "change"
                        }
                    ],
                    overtimeApproved: [
                        {
                            required: true,
                            message: this.$t('shared.pleaseSelectOvertimeApproved'),
                            trigger: "change"
                        }
                    ],
                },
                formChangeEmail: {
                    serviceCompany: null,
                    phone: null,
                    email: null,
                    useCustom: false
                },
                loading: false,
                showDialog: this.visible,
                fileUrlPreview: null,
                showImagePreview: false,
                serviceTicketNumber: null,
                previousTickets: [],
                showSaveDialog: false,
                loadingChangeEmail: false,
                ticketToEdit: null,
                equipmentWrtEnd: null,
                fileExtension: undefined,
                currentPreviousTicketsPage: 1,
                previousTicketsPageSize: 4,
                previousTicketsTotal: 0,
                previousTicketsButtonDisabled: false
            };
        },
        watch: {
            "form.customerId": function (val, oldVal) {
                if (this.form.customerId) {
                    api.customerIsRs(this.form.customerId).then(response => {
                        if (response && response.data && response.data === true) {
                            this.showRsMessage = true;
                        }
                    });
                }
                this.getServiceCompanyCredentials();
                if (this.form.customerId && oldVal === undefined) {
                    return;
                }
                this.form.equipmentId = undefined;
            },
            "form.equipmentId": function (val, oldVal) {
                if (val != undefined && val != null && val != "") {
                    api.getPreviousTickets(val, this.previousTicketsPage, this.previousTicketsPageSize).then(response => {
                        this.previousTickets = response.data.items;
                        this.previousTicketsTotal = response.data.total;
                        if (response.data.items.length < this.previousTicketsPageSize || response.data.items.length === response.data.total) {
                            this.previousTicketsButtonDisabled = true;
                        }
                    });
                }
            },
            "form.categoryName": function (val) {
                if (val != undefined && val != null && val != "") {
                    this.form.subCategories = this.form.categories.filter(e => e.category == val)[0].subCategories;
                    this.form.subCategoryName = undefined;
                }
                else {
                    this.form.subCategories = [];
                    this.form.subCategoryName = undefined;
                }
            },
            "form.status": function (val, oldVal) {
                switch (val) {
                    case 1:
                        this.form.notes = "";
                        break;
                    case 3:
                        this.form.notes = "FLAGGED CALL - *** Tech MUST call Hardt at 1-800-387-6847 upon arrival to work with tech support and report findings. **** Please provide techs ETA to service@hardt.ca. Thank you.";
                        break;
                    case 5:
                        this.form.notes = "ESCALATION - ***Tech MUST call tech support from site at 1-800-387-6847 UPON ARRIVAL to report findings and for further support. *** We need a technician scheduled as soon as possible today or 1st call tomorrow at the latest. Thank you.";
                        break;
                    case 8:
                        this.form.notes = "***Please call the Customer at the number provided above to SCHEDULE or PROVIDE TECH\'S ETA upon receiving this ticket.***";
                        break;
                }
            },
            visible: function (val) {
                this.showDialog = val;
                if (val) {
                    this.loadTicket();
                }
            }
        },
        methods: {
            scrollToElement(options) {
                const el = this.$el.getElementsByClassName('Customer')[0];

                if (el) {
                    el.scrollIntoView(options);
                }
            },
            loadTicket() {
                if (this.ticketId) {
                    this.loading = true;
                    api.getServiceRequest(this.ticketId).then(response => {
                        this.loading = false;
                        if (response.data.success) {
                            const ticket = response.data.ticket;
                            this.form = Object.assign({}, ticket, {
                                requestorEmail: ticket.email,
                                serviceCoverage: undefined,
                                notes: ticket.explanationOfIssue ? ticket.explanationOfIssue : "",
                                callerTitle: Number(ticket.requestorTitleId),
                                complaintCodes: [],
                                categories: [],
                                customerName: ticket.customerName,
                            });
                            this.serviceCoverageName = undefined;
                            this.callerTitleValue = ticket.callerTitleValue;
                            this.urgencyValue = ticket.urgencyValue;
                            this.equipmentWrtEnd = ticket.warrantyEndFormatted;

                            if (!ticket.customerId) {
                                this.form.customerId = undefined;
                                this.form.equipmentId = undefined;
                            }

                            if (ticket.complaint && ticket.customerId) {
                                this.appendCode({
                                    id: ticket.complaint.id,
                                    name: `${ticket.complaint.code} - ${ticket.complaint.description}`
                                });
                            }

                           
                            api.getComplaintCodeCategories().then(response => {
                                this.form.categories = response.data;
                            });

                            this.getServiceCompanyCredentials();

                        } else {
                            this.$notify({
                                title: "Error",
                                message: response.data.message,
                                type: "error"
                            });
                            this.copyticket = false;
                        }
                    });
                }
            },
            appendCode(code) {
                if (this.form.complaintCodes.indexOf(code) === -1) {
                    this.form.complaintCodes.push(code);
                }
            },
            removeCode(code)
            {
                this.form.complaintCodes = this.form.complaintCodes.filter(
                    c => c.id != code
                );
            },
            closeDialog() {              
                this.formChangeEmail.serviceCompany = null;
                this.formChangeEmail.phone = null;
                this.formChangeEmail.email = null;
                this.formChangeEmail.useCustom = false;
                this.$refs["form"].resetFields();
                this.form.complaintCodes = [];
                this.showDialog = false;
                this.previousTickets = [];
                this.loading = false;
                this.showSaveDialog = false;
                this.isCopy = false;
                this.isSavingInProgress = false;
                this.$emit("dialogClosed");
                this.previousTicketsTotal = 0;
                this.previousTicketsButtonDisabled = false;
                this.currentPreviousTicketsPage = 1;
            },
            save(sendEmail, isEmailFormValied) {
                this.showSaveDialog = false;
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.$refs["form"].loading = true;
                        this.isSavingInProgress = true;
                        this.form.status = this.form.status || "1"; // service ticket opened value
                        if (this.formChangeEmail.useCustom) {
                            if (isEmailFormValied) {
                                api
                                    .saveTicket(
                                        sendEmail,
                                        this.form,
                                        this.serviceTicketNumber,
                                        this.formChangeEmail
                                    )
                                    .then(() => {
                                        this.$notify({
                                            title: "Success",
                                            message: 'Ticket successfully saved.',
                                            type: "success"
                                        });
                                        this.closeDialog();
                                    })
                                    .catch(response => {
                                        this.$notify({
                                            title: "Error",
                                            message: response.response.data,
                                            type: "error"
                                        });
                                        this.loading = false;
                                        this.isSavingInProgress = false;
                                    });
                            } else {
                                return false;
                            }
                        } else {
                            api
                                .saveTicket(sendEmail, this.form, this.serviceTicketNumber)
                                .then(() =>
                                {
                                    if (!this.isCopy)
                                    {
                                        this.$notify({
                                            title: "Success",
                                            message: 'Ticket successfully saved.',
                                            type: "success"
                                        });
                                        this.closeDialog();
                                    }
                                    else
                                    {
                                        this.$notify({
                                            title: "Success",
                                            message: 'Ticket successfully saved.',
                                            type: "success"
                                        });
                                        api.getComplaintCodeCategories().then(response =>
                                        {
                                            this.form.categories = response.data
                                        });
                                        this.form.status = undefined;
                                        this.form.equipmentId = undefined;
                                        this.form.categoryName = undefined;
                                        this.form.equipmentName = undefined;
                                        this.form.subCategoryName = undefined;
                                        this.form.overtimeApproved = undefined;
                                        this.form.isConfirmationOnly = false;
                                        this.form.urgency = undefined;
                                        this.form.notes = "";
                                        this.form.status = undefined;
                                        this.form.serviceCoverage = undefined;
                                        this.form.complaintCodes = [];
                                        this.form.attachments = [];
                                        this.form.subCategories = [];
                                        this.form.responseTime = -1;
                                        this.isSavingInProgress = false;
                                        this.isCopy = false;

                                        this.scrollToElement({ behavior: 'smooth' });
                                    }

                                })
                                .catch(response => {
                                    this.$notify({
                                        title: "Error",
                                        message: response.response.data,
                                        type: "error"
                                    });
                                    this.loading = false;
                                    this.isSavingInProgress = false;
                                });

                        }
                    }
                    else {
                        return false;
                    }
                });
            },
            close() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.form.status = this.form.status || "1"; // service ticket opened value
                        api
                            .saveTicket(null, this.form, this.serviceTicketNumber)
                            .then(() => {
                                this.closeDialog();
                            })
                            .catch(response => {
                                this.$notify({
                                    title: "Error",
                                    message: response.response.data,
                                    type: "error"
                                });
                                this.loading = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            attachmentChanged(file, fileList) {
                this.form.attachments.push(file.raw);
            },
            handlePreview(file) {
                var split = file.name.split(".");
                this.fileExtension = split[split.length - 1];
                if (!file.url) {
                    return;
                }
                if (
                    this.fileExtension !== "jpg" &&
                    this.fileExtension !== "pdf" &&
                    this.fileExtension !== "jpeg" &&
                    this.fileExtension !== "png"
                ) {
                    window.open(file.url);
                    return;
                }
                this.fileUrlPreview = file.url;
                this.showImagePreview = true;
            },
            getServiceCompanyCredentials() {
                if (this.form && this.form.customerId) {
                    this.loadingChangeEmail = true;
                    api
                        .getServiceCompanyCredentials(this.form.customerId)
                        .then(response => {
                            this.formChangeEmail.email = response.data.email;
                            this.formChangeEmail.phone = response.data.phone;
                            this.formChangeEmail.serviceCompany = response.data.serviceCompany;
                            this.loadingChangeEmail = false;
                        });
                }
            },
            copyAndSave()
            {
                this.showEmailDialog();
                this.isCopy = true;
            },
            showEmailDialog()
            {
                if (this.form.complaintCodes.length === 0) {
                    this.$message.error("At least one symptom code should be added");
                    return;
                }
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.showSaveDialog = true;
                    } else {
                        return false;
                    }
                });
            },
            editFinished() {
                this.ticketToEdit = null;
                this.dialogVisible = false;
            },
            editTicket(id) {
                this.ticketToEdit = id;
                this.dialogVisible = true;
            },
            viewrsprocedures() {
                window.open(
                    "static/RS Procedure Technical Support.pdf",
                    "_blank",
                    "width=600,height=800,toolbar=1"
                );
                this.showRsMessage = false;
            },
            equipmentSelected(equipment) {
                this.equipmentWrtEnd = equipment.warrantyEndFormatted;
                this.form.equipmentName = equipment.model;
            },
            getMorePreviousTickets() {
                if ((this.currentPreviousTicketsPage * this.previousTicketsPageSize) < this.previousTicketsTotal) {
                    api.getPreviousTickets(this.form.equipmentId, this.currentPreviousTicketsPage + 1, this.previousTicketsPageSize).then(response => {
                        if (response.data.items.length > 0) {
                            this.currentPreviousTicketsPage = this.currentPreviousTicketsPage + 1;
                            this.previousTickets = [...this.previousTickets, ...response.data.items];
                            this.previousTicketsTotal = response.data.total;

                            if (response.data.items.length < this.previousTicketsPageSize || (this.currentPreviousTicketsPage * this.previousTicketsPageSize) === this.previousTicketsTotal) {
                                this.previousTicketsButtonDisabled = true;
                            }
                        }
                        else {
                            this.previousTicketsButtonDisabled = true;
                        }
                    });
                }
                else {
                    this.previousTicketsButtonDisabled = true;
                }
            },
            deleteServiceRequest() {
                this.$confirm(
                    'Are you sure you want to delete the service request?',
                    'Warning',
                    {
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }
                ).then(() => {
                    api.deleteServiceRequest(this.form.id).then(() => {
                        this.loading = false;
                        this.closeDialog();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        })
                    });
                }).catch(_ => { });
            }
        },
        mounted()
        {
            this.loading = true;
            api.getComplaintCodeCategories().then(response => {
                this.loading = false
                this.form.categories = response.data
            });
        }
    };
</script>

<style scoped>
    .full-width,
    .code {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/costcoservicerequests/components/CreateServiceTicketFromDraftDialog.vue